import { useEffect, useState } from 'react';
import { ToastContainer} from 'react-toastify';
import { ErrorBoundary } from "react-error-boundary";
import { ErrorInfo } from "react";

// Styles
import './App.css';

// Context
import { useNavigationContext } from './Context/NavigationContext';
import { useGlobalContext } from './Context/GlobalContext';

function App() {
  const { current, navigateTo, changeLandingView } = useNavigationContext();
  const { popup, subPopup, dbManager, getThemeStyles } = useGlobalContext();
  const [isSupported, setIsSupported] = useState<boolean>(true);

  useEffect(() => {
    const init = async () => {
      if (!navigator.usb) {
        setIsSupported(false);
      } else if (window.location.pathname.split('/')[1] === 'testmode') {
        navigateTo('testMode');
      } else if (window.location.pathname.split('/')[1] === 'firmware') {
        navigateTo('firmware');
      } else {
        await dbManager.init();
        if (window.location.pathname.split('/')[1] === 'reset') changeLandingView('reset');
        navigateTo('landing');
      }
    }
    init();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dbManager]);

  const logError = (error: Error, info: ErrorInfo) => { 
    dbManager.log(error.message + '\n' + info.componentStack)
  };

  const ErrorScreen = () => {
    return (
      <div className='error-screen'>
        <div>
          <h1>Something went wrong</h1>
          <p>Please refresh the page and try again</p>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary fallback={<ErrorScreen />} onError={logError}>
      <div className="view-base" style={getThemeStyles()}>
        <style>{`
          body {
            background-color: ${getThemeStyles()['--theme-bg-color']}
          }
        `}</style>
        <ToastContainer theme="dark"/>
        {popup}
        {subPopup}
        <div className={popup ? 'blur' : ''} style={{height: '100%'}}>
          {isSupported ? current : <div className="unsupported">
            <div>
              <div>WebUSB is not supported on this browser</div>
              <div style={{marginTop: '40px'}}>For access to Modemaker please use:</div>
              <div style={{marginTop: '20px'}}>Chrome</div>
              <div>Edge</div>
              <div>Opera</div>
            </div>
          </div>}
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default App;
